export default __webpack_public_path__ + "static/media/deathsterror.70fcf5bb.png";